import { render, staticRenderFns } from "./ListVolume.vue?vue&type=template&id=50d49f86"
import script from "./ListVolume.vue?vue&type=script&lang=js"
export * from "./ListVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports